import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class ABExperimentConfigService {
	constructor(private configService: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getLabelToIdentifierMap(): Record<string, string> {
		return this.configService.get((config) => config.core.abExperiment.labelToIdentifierMap, {});
	}

	getLabelToConfigMap(): Record<
		string,
		{
			country?: { include?: string[]; exclude?: string[] };
		}
	> {
		return {
			pm: {
				country: {
					exclude: ["MT"],
				},
			},
		};
	}
}
